/**
 * @flow
 * @relayHash 47a07c2a10af6492466033b878cf24ca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getContactsQueryVariables = {|
  propertyId: string
|};
export type getContactsQueryResponse = {|
  +contactGroups: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +status: string,
    +count: number,
    +reachableCount: number,
    +mmsCount: number,
    +mmsReachableCount: number,
    +createdAt: any,
  |}>
|};
export type getContactsQuery = {|
  variables: getContactsQueryVariables,
  response: getContactsQueryResponse,
|};
*/


/*
query getContactsQuery(
  $propertyId: ID!
) {
  contactGroups(propertyId: $propertyId) {
    id
    name
    status
    count
    reachableCount
    mmsCount
    mmsReachableCount
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contactGroups",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      }
    ],
    "concreteType": "ContactGroup",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "count",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reachableCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "mmsCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "mmsReachableCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getContactsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getContactsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getContactsQuery",
    "id": null,
    "text": "query getContactsQuery(\n  $propertyId: ID!\n) {\n  contactGroups(propertyId: $propertyId) {\n    id\n    name\n    status\n    count\n    reachableCount\n    mmsCount\n    mmsReachableCount\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f983497613238e9c8554f4662cc20c61';
module.exports = node;
